export const FULL_CHEQUE_PAYMENT_MESSAGE =
  'Não é possível realizar o pagamento total utilizando cheque.';

export const parsePaymentAmountInCents = (amount?: string | null): number => {
  if (!amount) {
    return 0;
  }

  return Number(amount.replace(/\D/g, ''));
};

export const getPaymentTotalInCents = (
  totalPaymentValue?: number | null
): number => Math.round((totalPaymentValue ?? 0) * 100);

export const isFullChequePaymentAmount = ({
  chequeAmount,
  totalPaymentValue,
}: {
  chequeAmount?: string | null;
  totalPaymentValue?: number | null;
}): boolean => {
  const totalInCents = getPaymentTotalInCents(totalPaymentValue);
  const chequeAmountInCents = parsePaymentAmountInCents(chequeAmount);

  return (
    totalInCents > 0 &&
    chequeAmountInCents > 0 &&
    chequeAmountInCents >= totalInCents
  );
};
